export * from '@/lib/api/types/page-result';

export type QueryParamValue = string | number | boolean | undefined;
export type QueryParams = Record<string, QueryParamValue>;

export type ApiError = {
  name: 'ApiError';
  message: string;
  status: number;
  code?: string;
  details?: Record<string, unknown>;
  errorId?: string;
  traceId?: string;
  body?: unknown;
};

export type NetworkError = {
  name: 'NetworkError';
  message: string;
  status: 0;
};

export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    error.name === 'ApiError' &&
    'status' in error &&
    'message' in error
  );
}

export function isNetworkError(error: unknown): error is NetworkError {
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    error.name === 'NetworkError' &&
    'status' in error &&
    error.status === 0
  );
}
